import { Form, Input } from 'antd';
import React, { useState } from 'react';
import FormPage from '../../../../../components/pages/FormPage';

const DefModel = {
    name: ''
}

export default () => {
    const [model, setModel] = useState(DefModel);
    return (
        <FormPage
            url={'api/v1/notify'}
            formValid={false}
            model={model}
            setModel={setModel}
            wrapperCol={{ span: 8 }}
            labelCol={{ span: 3 }}
            title={"Notify"}
            emptyModel={DefModel}
            callbackPath={"/master/notify"}
        >
            <Form.Item name={'npwp'} label="npwp" rules={[{ required: true }]} >
                <Input autoComplete="off" onInput={e => e.target.value = e.target.value} autoFocus />
            </Form.Item>
            <Form.Item name={'name'} label="name" rules={[{ required: true }]} >
                <Input autoComplete="off" onInput={e => e.target.value = e.target.value} autoFocus />
            </Form.Item>
            <Form.Item name={'country'} label="country code" rules={[{ required: true }]} >
                <Input autoComplete="off" onInput={e => e.target.value = e.target.value} autoFocus />
            </Form.Item>
            <Form.Item name={'address'} label="address 1" rules={[{ required: true }]} >
                <Input autoComplete="off" onInput={e => e.target.value = e.target.value} autoFocus />
            </Form.Item>
            <Form.Item name={'address2'} label="address 2" rules={[{ required: true }]} >
                <Input autoComplete="off" onInput={e => e.target.value = e.target.value} autoFocus />
            </Form.Item>
            <Form.Item name={'address3'} label="address 3" rules={[{ required: true }]} >
                <Input autoComplete="off" onInput={e => e.target.value = e.target.value} autoFocus />
            </Form.Item>
            <Form.Item name={'address4'} label="address 4" rules={[{ required: true }]} >
                <Input autoComplete="off" onInput={e => e.target.value = e.target.value} autoFocus />
            </Form.Item>
            <Form.Item name={'address5'} label="address 5" rules={[{ required: true }]} >
                <Input autoComplete="off" onInput={e => e.target.value = e.target.value} autoFocus />
            </Form.Item>
        </FormPage>
    )
}
